// Centralised data-testid constants
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const TID = {
  header: "site-header",
  brand: "brand-datespeak",
  navDecode: "nav-decode",
  navFups: "nav-fups",
  navHow: "nav-how",

  heroSection: "hero-section",
  heroTitle: "hero-title",
  heroCta: "hero-cta-decode-now",
  heroTicker: "hero-ticker",

  decoderSection: "decoder-section",
  tabText: "decoder-tab-text",
  tabImage: "decoder-tab-image",
  textInput: "decoder-text-input",
  imageDropzone: "decoder-image-dropzone",
  imageFileInput: "decoder-image-file-input",
  imagePreview: "decoder-image-preview",
  speakerSelect: "decoder-speaker-select",
  submit: "decoder-submit",
  clear: "decoder-clear",
  output: "decoder-output",
  outputMeaning: "decoder-output-meaning",
  outputIntent: "decoder-output-intent",
  outputReply: "decoder-output-reply",
  outputFramework: "decoder-output-framework",
  outputNotAboutYou: "decoder-output-not-about-you",
  outputActionable: "decoder-output-actionable",
  outputRedFlags: "decoder-output-red-flags",
  outputGreenFlags: "decoder-output-green-flags",

  fupsSection: "fups-section",
  fupsSearch: "fups-search",
  fupsGenderAll: "fups-gender-all",
  fupsGenderMale: "fups-gender-male",
  fupsGenderFemale: "fups-gender-female",
  fupsIntent: "fups-intent-filter",
  fupsCard: (id) => `fups-card-${id}`,
  fupsCount: "fups-count",
};
